import { Text, View, StyleSheet } from "@react-pdf/renderer";
import React, { useMemo } from "react";
import { Setting } from "../../../generated/graphql";

const InvoiceNotes: React.FC<{ settings?: Setting[] }> = ({ settings }) => {
  const note = useMemo(() => {
    return settings?.find((elm) => elm.key === "importantNotes");
  }, [settings]);

  const notes = note?.value.split("\n");

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Important Notes</Text>
      {notes?.map((elm, index) => (
        <View style={styles.descItem} key={index}>
          <View style={styles.bullet}></View>
          <Text style={styles.description}>{elm}</Text>
        </View>
      ))}
    </View>
  );
};

// Create styles
const styles = StyleSheet.create({
  container: {
    borderTop: "1px solid #000",
    paddingTop: 10,
    marginBottom: 10,
    fontFamily: "Poppins",
    fontSize: 8,
    paddingLeft: 4,
    paddingRight: 4,
  },
  title: {
    fontWeight: 600,
    marginBottom: 2,
  },
  descItem: {
    display: "flex",
    flexDirection: "row",
    gap: 4,
    paddingLeft: 4,
  },
  description: {
    marginBottom: 2,
  },
  bullet: {
    width: 3,
    height: 3,
    borderRadius: 10,
    marginTop: 3,
    backgroundColor: "#000",
  },
});

export default InvoiceNotes;
